export class Factory {
    static registerComponent(key, component) {
        Factory._components[key] = component;
    }
    static getComponent(key) {
        return Factory._components[key];
    }
    static registerFunction(key, func) {
        Factory._functions[key] = func;
    }
    static getFunction(key) {
        return Factory._functions[key];
    }
    static registerCellType(key, cellType) {
        Factory._cellTypes[key] = cellType;
    }
    static getCellType(key) {
        return Factory._cellTypes[key];
    }
}

Factory._components = {}, Factory._functions = {}, Factory._cellTypes = {};
//# sourceMappingURL=factory.js.map